// Maps app routes to relevant help article slugs
const CONTEXTUAL_HELP = {
  "/DashboardView": ["premiere-connexion", "navigation-interface", "organisation-parc", "vue-live-timeline"],
  "/LiveSectorView": ["vue-live-timeline", "gestion-taches", "organisation-parc"],
  "/Timeline": ["vue-live-timeline", "navigation-interface"],
  "/AnimalManagementView": ["fiche-individu", "ajouter-animal", "creation-import-animaux", "notes-collaboration", "evaluation-rapide-individuelle", "entrainement-medical-training"],
  "/TrainingExercisesView": ["entrainement-medical-training"],
  "/TrainingDashboardView": ["entrainement-medical-training"],
  "/SpecieAnimalListView": ["ajouter-animal", "creation-import-animaux", "transfert-animaux", "doublons-animaux"],
  "/ZimsCollection": ["synchro-zims", "creation-import-animaux"],
  "/CampaignCreationView": ["creer-campagne", "campagnes-pedago-training", "outils-evaluation"],
  "/CampaignListView": ["suivre-campagne", "creer-campagne", "campagnes-pedago-training", "outils-evaluation"],
  "/CampaignQuizzMonitoringView": ["suivre-campagne", "exporter-donnees-campagne", "campagnes-pedago-training"],
  "/GridBuilderView": ["creer-grille-evaluation", "outils-evaluation"],
  "/GridManagementView": ["creer-grille-evaluation", "outils-evaluation"],
  "/GridDetailView": ["creer-grille-evaluation", "evaluer-animaux"],
  "/FastEvaluationView": ["evaluer-animaux", "outils-evaluation"],
  "/FastEvalGroupListView": ["evaluer-animaux", "groupes-evaluation", "outils-evaluation", "suivi-bien-etre-objectifs-actions"],
  "/AdvancedGroupManagementView": ["groupes-evaluation"],
  "/ObjectivesListView": ["suivi-bien-etre-objectifs-actions", "groupes-evaluation"],
  "/GroupActionsView": ["suivi-bien-etre-objectifs-actions", "groupes-evaluation"],
  "/QuizzListViewReadOnly": ["outils-evaluation"],
  "/obsListViewReadOnly": ["outils-evaluation"],
  "/SectorListView": ["organisation-parc", "configurer-rapport"],
  "/SectorManagementView": ["organisation-parc", "configurer-rapport", "parametres-suivis-rapports", "remplir-rapport-journalier", "rafiki-assistant-ia", "notes-collaboration", "demandes-reponse-sla", "meteo-du-parc"],
  "/EnclosureManagementView": ["organisation-parc", "gestion-enclos", "transfert-animaux", "parametres-environnementaux", "exporter-enrichissements", "notes-collaboration", "meteo-du-parc"],
  "/WeatherView": ["meteo-du-parc", "analyse-scan", "analyse-focale"],
  "/EnclosureListView": ["organisation-parc", "gestion-enclos"],
  "/EnrichListView": ["catalogue-enrichissements", "exporter-enrichissements", "planifier-session", "guides-enrichissements"],
  "/EnrichmentGuidesView": ["guides-enrichissements", "catalogue-enrichissements"],
  "/EnrichmentGuideDetailView": ["guides-enrichissements", "catalogue-enrichissements"],
  "/EnrichmentGuideEditorView": ["guides-enrichissements"],
  "/IndividualFastEvalListView": ["evaluation-rapide-individuelle", "evaluer-animaux", "creer-grille-evaluation"],
  "/EnrichmentAnalysisListView": ["analyser-enrichissements", "exporter-enrichissements"],
  "/QuizzAnalysisView": ["analyse-questionnaires", "outils-evaluation"],
  "/ScanResultView": ["analyse-scan", "outils-evaluation", "meteo-du-parc"],
  "/FocalAnalysisView": ["analyse-focale", "outils-evaluation", "meteo-du-parc"],
  "/ZooDetails": ["parametres-zoo", "gestion-utilisateurs", "synchro-zims", "meteo-du-parc"],
  "/TourneeListView": ["organisation-parc", "creer-gerer-tournee", "utiliser-tournee-mobile"],
  "/TourneeManagementView": ["creer-gerer-tournee", "configurer-rapport", "parametres-suivis-rapports", "rafiki-assistant-ia"],
  "/RafikiFullView": ["rafiki-assistant-ia"],
  "/EngagementView": ["badges-et-classement"],
  "/TaskManagementView": ["gestion-taches", "taches-veterinaires", "gestion-prescriptions"],
  "/VeterinaryDashboardView": ["suivi-sante", "gestion-prescriptions", "types-ordonnances", "taches-veterinaires"],
  "/TechnicalDashboardView": ["module-technique-maintenance", "gestion-taches", "gestion-enclos"],
  "/VeterinaryParametersView": ["suivi-sante"],
  "/HelpCenterView": ["tickets-support", "navigation-interface"],
  "/SpecieListManagement": ["gestion-especes", "ajouter-animal", "outils-evaluation"],
  "/SpecieManagementView": ["gestion-especes", "ajouter-animal"],
  "/SpecieQA": ["gestion-especes", "outils-evaluation"],
  "/IUCNSpeciesSearch": ["gestion-especes"],
  "/IUCNMigrationTool": ["gestion-especes"],
};

export default CONTEXTUAL_HELP;
